import React, { useEffect, useState } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import "../styles/pages/cabgrid.css";
import iconEntrega from "../images/car-black-icon.svg";
import iconMontagem from "../images/tools-icon.svg";
import iconImpermeabilizacaoSofa from "../images/waterproof-sofa.png";
import iconImpermeabilizacaoChair from "../images/waterproof-chair.png";
import iconImpermeabilizacaoArmchair from "../images/waterproof-armchair.png";
import IconArrowDown from '../images/arrow-down.svg';
import api from "../services/api";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
  })
);
interface PropriedadesCabGrid {
  descricaoItem?: string;
  quantidadePreco?: string;
  dataEntrega?: string;
  dataMontagem?: string;
  dtImpermeabilizacao?: string;
  dataEntregaAg?: string;
  dataRetirada?: string;
  isRetirada?: boolean;
  transportadora?: string;
  isRoteiro?: boolean;
  dtRotaEntrega?: string;
  chCriacao?: number;
  orderId?: string;
  status?: number;
  codigo?: string;
  zDataAgendada?: string;
  docCliente: string;
}

export default function CabGrid(props: PropriedadesCabGrid) {
  const classes = useStyles();
  const documento = props.docCliente ? props.docCliente : '';

  const [dataRota, setDataRota] = useState(null);
  const [horarioRota, setHorarioRota] = useState(null);
  const [horarioMontagem, setHorarioMontagem] = useState(null);
  const [openHelloModal, setOpenHelloModal] = useState(false);
  const transportadorasRoteiro: Number[] = [8, 14, 15, 16, 17, 18] //roteiro
  const transportadorasAgendado: Number[] = [55, 66, 67, 68] //I9 agendada
  let isRoteiro = false
  let isAgendada = props.zDataAgendada ? true : false;

  const isHelloTransportadora = props.transportadora == '122' 
  || props.transportadora == '23'
  || props.transportadora == '50'
  || props.transportadora == '51'
  || props.transportadora == '52'
  || props.transportadora == '53'
  || props.transportadora == '54'
  || props.transportadora == '55'
  || props.transportadora == '66'
  || props.transportadora == '67'
  || props.transportadora == '68'
  || props.transportadora == '70'
  || props.transportadora == '75'
  || props.transportadora == '76'
  || props.transportadora == '77'
  || props.transportadora == '78'
  || props.transportadora == '79'
  || props.transportadora == '80'
  || props.transportadora == '81' 
  || props.transportadora == '82'
  || props.transportadora == '83'
  || props.transportadora == '84'
  || props.transportadora == '92'
  || props.transportadora == '93'
  || props.transportadora == '99' 
  || props.transportadora == '100' 
  || props.transportadora == '101' 
  || props.transportadora == '102'
  || props.transportadora == '103';

  const showHelloInfo = isHelloTransportadora;


  if (!isRoteiro) {
    if (props) {
      if (props.isRoteiro) {
        isRoteiro = props.isRoteiro
      } else if (props.transportadora) {
        isRoteiro = transportadorasRoteiro.find((el) => el.toString() == props.transportadora) ? true : false
      }
    }
  }

  if (!isAgendada) {
    if (props) {
      if (props.transportadora) {
        isAgendada = transportadorasAgendado.find((el) => el.toString() == props.transportadora) ? true : false
      }
    }
  }

  async function getInfoRota(chCriacao: string, type: string, codigo: string) {
    const response = await api.get(`/pedidos/infoRota/${chCriacao}/${type}/${codigo}`);
    if (response.status == 200) return response.data
  }

  async function getInfoMontagem(documento: string) {
    console.log('documento', documento)
    const response = await api.get(`/pedidos/infoHorarioMontagem/${documento}`);
    if (response.status == 200) return response.data
  }

  useEffect(() => {
    const fetchData = async (dataAtual: string) => {
      try {
        if (props.chCriacao || props.orderId) {
          let result = null
          if (props.codigo) {
            if (props.chCriacao) {
              result = await getInfoRota(props.chCriacao.toString(), 'chCriacao', props.codigo)
            } else if (props.orderId) {
              result = await getInfoRota(props.orderId, 'orderId', props.codigo)
            }
          }

          if (result.sucesso && result.dataFormatada == dataAtual) {
            setDataRota(result.dataFormatada);
            setHorarioRota(result.horario);
          }
        }
      } catch (error) {
        console.error('Erro:', error);
      }
    };

    const fetchDataMontagem = async (documento: string, dataAtual: string) => {
      try {
        if (documento) {
          const chaveMontagem = await getInfoMontagem(documento);
          if (chaveMontagem && chaveMontagem.dataFormatada == dataAtual) {
            setHorarioMontagem(chaveMontagem.horario);
          }
        }
      } catch (error) {
        console.error('Erro:', error);
      }
    }

    if (isRoteiro && props.status == 314 && props.dataEntregaAg && props.dataEntregaAg !== '') { //apenas roteiro, entregue a transportadora e com data de entrega
      let elementosData = props.dataEntregaAg.split("/");
      let dataRotaString = elementosData[1] + "/" + elementosData[0] + "/" + elementosData[2];
      let novaDataRota = new Date(dataRotaString);
      let hoje = new Date();

      let dataRota = null;
      let dataAtual = null;

      if (hoje.getHours() < 9) return

      hoje.setHours(0, 0, 0, 0)

      let dia = ('0' + novaDataRota.getDate()).slice(-2);
      let mes = ('0' + (novaDataRota.getMonth() + 1)).slice(-2);
      let ano = novaDataRota.getFullYear();

      dataRota = dia + '/' + mes + '/' + ano;

      let diaAtual = ('0' + hoje.getDate()).slice(-2);
      let mesAtual = ('0' + (hoje.getMonth() + 1)).slice(-2);
      let anoAtual = hoje.getFullYear();

      dataAtual = diaAtual + '/' + mesAtual + '/' + anoAtual;

      if (dataRota == dataAtual) fetchData(dataAtual); //apenas no dia da entrega
    }

    if (props.dataMontagem && props.dataMontagem !== '') {
      let elementosData = props.dataMontagem.split("/");
      let dataMontagemString = elementosData[1] + "/" + elementosData[0] + "/" + elementosData[2];
      let novaDataMontagem = new Date(dataMontagemString);
      let hoje = new Date();

      let dataMontagem = null;
      let dataAtual = null;

      if (hoje.getHours() < 9) return

      hoje.setHours(0, 0, 0, 0)

      let dia = ('0' + novaDataMontagem.getDate()).slice(-2);
      let mes = ('0' + (novaDataMontagem.getMonth() + 1)).slice(-2);
      let ano = novaDataMontagem.getFullYear();

      dataMontagem = dia + '/' + mes + '/' + ano;

      let diaAtual = ('0' + hoje.getDate()).slice(-2);
      let mesAtual = ('0' + (hoje.getMonth() + 1)).slice(-2);
      let anoAtual = hoje.getFullYear();

      dataAtual = diaAtual + '/' + mesAtual + '/' + anoAtual;

      if (dataMontagem == dataAtual && documento) fetchDataMontagem(props.docCliente, dataAtual); //apenas no dia da montagem
    }
  }, []);

  return (
    <div className={classes.root}>
      <div className="cabgrid-content">
        <img className="cabgrid-arrow-down" src={IconArrowDown} alt="arrow-down" />
        <div className="cabgrid-left-content">
          <span className="cabgrid-desc-item">{props.descricaoItem}</span>
          <span className="cabgrid-preco-item">{props.quantidadePreco}</span>
        </div>
        <div className="cabgrid-right-content">
          {!dataRota && !props.isRetirada && props.dataEntregaAg && isRoteiro && !isAgendada && (
            <div className="cabgrid-data-entrega-agendada">
              <img src={iconEntrega} alt="data_entrega_agendada" />
              <span>Entrega Agendada</span>
              <strong>{props.dataEntregaAg}</strong>
            </div>
          )}
          {!dataRota && !props.isRetirada && props.zDataAgendada && !isRoteiro && isAgendada && (
            <div className="cabgrid-data-entrega-agendada">
              <img src={iconEntrega} alt="data_entrega_agendada" />
              <span>Entrega Agendada</span>
              <strong>{props.zDataAgendada}</strong>
            </div>
          )}
          {/* { props.dataEntrega && (
            <div className="cabgrid-data-entrega">
              <img src={iconEntrega} alt="data_entrega" />
              <span>Data Limite de Entrega </span>
              <strong>{props.dataEntrega}</strong>
            </div>
          )} */}
          {dataRota && horarioRota && (
            <div className="cabgrid-data-entrega">
              <img src={iconEntrega} alt="data_entrega" />
              <span>Entrega Agendada</span>
              <strong>{dataRota}</strong>
              <strong>{horarioRota}</strong>
            </div>
          )}
          {props.isRetirada && props.dataRetirada && (
            <div className="cabgrid-retirada">
              <img src={iconEntrega} alt="data_retirada" />
              <span>Retirada</span>
              <strong>{props.dataRetirada}</strong>
            </div>
          )}
          {props.dataMontagem && (
            <div className="cabgrid-montagem">
              <img src={iconMontagem} alt="data_montagem" />
              <span>Montagem</span>
              <strong>{props.dataMontagem}</strong>
              <strong>{horarioMontagem}</strong>
              {showHelloInfo && (
                <button
                  type="button"
                  className="cabgrid-montagem-hello-button"
                  onClick={() => setOpenHelloModal(true)}
                >
                  Regras da transportadora Hello
                </button>
              )}
            </div>
          )}
          {
            props.dtImpermeabilizacao && props.descricaoItem?.toLowerCase()?.includes('cadeira') ?
              (<>
                <div className="cabgrid-impermeabilizacao">
                  <img src={iconImpermeabilizacaoChair} alt="data_impermeabilizacao" />
                  <span>Impermeabilização</span>
                  <strong>{props.dtImpermeabilizacao}</strong>
                </div>
              </>) :
              props.dtImpermeabilizacao && props.descricaoItem?.toLowerCase()?.includes('poltrona') ?
                (
                  <>
                    <div className="cabgrid-impermeabilizacao">
                      <img src={iconImpermeabilizacaoArmchair} alt="data_impermeabilizacao" />
                      <span>Impermeabilização</span>
                      <strong>{props.dtImpermeabilizacao}</strong>
                    </div>
                  </>
                ) : (
                  props.dtImpermeabilizacao && (
                    <>
                      <div className="cabgrid-impermeabilizacao">
                        <img src={iconImpermeabilizacaoSofa} alt="data_impermeabilizacao" />
                        <span>Impermeabilização</span>
                        <strong>{props.dtImpermeabilizacao}</strong>
                      </div>
                    </>
                  )
                )
          }
        </div>
      </div>
      {openHelloModal && (
        <div
          className="hello-modal-overlay"
          onClick={() => setOpenHelloModal(false)}
        >
          <div
            className="hello-modal"
            onClick={(event) => event.stopPropagation()}
          >
            <h2 className="hello-modal-title">Regras da transportadora Hello</h2>
            <ul className="hello-modal-list">
              <li>Horário de entrega: das 08h00 às 18h00.</li>
              <li>Tempo de espera no local: a equipe aguarda até 15 minutos.</li>
              <li>Os entregadores não cobram nenhuma taxa no momento da entrega para subidas pela escada.</li>
              <li>Caso a entrega não possa ser realizada por motivo relacionado ao cliente, uma nova tentativa será feita em até 6 dias úteis para capital e até 14 dias úteis para interior.</li>
              <li>Quando o produto não couber no elevador, a equipe realiza o transporte por escadas, limitado em até 6 lances.</li>
              <li>Se o item não puder ser transportado até o ambiente final, a entrega será concluída em um local alternativo definido pelo cliente ou responsável (como garagem, portaria etc.).</li>
              <li>Ao final do serviço, a Hello solicita a vistoria dos produtos e a assinatura do responsável, confirmando que estão em perfeitas condições.</li>
              <li>Clientes que não contrataram no ato da compra o tipo "entrega agendada" não podem escolher a data; o agendamento fica a critério do roteiro da transportadora.</li>
              <li>Caso, mesmo após as tentativas previstas, não seja possível realizar a entrega, o cliente deverá fazer a retirada do produto diretamente na loja Abra Casa Pinheiros, podendo haver cobrança de taxa extra.</li>
            </ul>
            <button
              type="button"
              className="hello-modal-close"
              onClick={() => setOpenHelloModal(false)}
            >
              Fechar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
